import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class RightMenuService {

  menuItem = new Subject<any>();
  menuID = new Subject<any>();

  constructor() { }

  triggerMenuItem(data: any): void{
    this.menuItem.next(data);
  }

  listenTriggeredMenuItem(): Observable<any> {
    return this.menuItem.asObservable();
  }

  sendRightMenuID(menuID: number): void {
    this.menuID.next({ ID: menuID });
  }

  getRightMenuID(): Observable<any> {
    return this.menuID.asObservable();
  }
}
